<template>
    <div style="height:100%;overflow:hidden;"
         :class="'containerNode'+classStr">
        <div :class="'listNode'+classStr"
             @mouseenter="Stop()"
             @mouseleave="Up()">
            <slot></slot>
        </div>
        <div :class="'listNodeCopy'+classStr"
             @mouseenter="Stop()"
             @mouseleave="Up()">
            <slot></slot>
        </div>
    </div>
</template>

<script>
  export default {
    name: "z-scroll-component",
    props: {
      classStr: {
        type: [String,Number],
        default: 0
      }
    },
    data() {
      return {
        intnum: null,
        speed: 60,
      }
    },
    methods: {
      ScrollUp() {
        console.log("点击滚动组件");
        this.$nextTick(() => {
          var ZJJDemo = document.getElementsByClassName('containerNode'+this.classStr)[0];
          var ZJJDemo1 = document.getElementsByClassName('listNode'+this.classStr)[0];
          var ZJJDemo2 = document.getElementsByClassName('listNodeCopy'+this.classStr)[0];
          if (ZJJDemo1.offsetHeight >= ZJJDemo.offsetHeight) {
            clearInterval(this.intnum);
            this.intnum = setInterval(() => {
              if (ZJJDemo2.offsetHeight - ZJJDemo.scrollTop <= 0) {
                ZJJDemo.scrollTop = ZJJDemo.scrollTop - ZJJDemo1.offsetHeight;
              } else {
                ZJJDemo.scrollTop++
              }
            }, this.speed);
          } else {
            ZJJDemo.scrollTop = 0;
            ZJJDemo2.innerHTML = '';
          }
        })
      },
      Stop() {
        clearInterval(this.intnum);
      },
      Up() {
        this.ScrollUp();
      },
    },
    mounted() {
      this.ScrollUp();
    }
  }
</script>

<style scoped>

</style>